import { css } from '@emotion/react'

interface Props {
  imageUrl: string
  text: string
}

export const InputHeader = ({ imageUrl, text }: Props) => {
  return (
    <header css={inputHeader}>
      <img style={{ width: 24, height: 24 }} src={imageUrl} />
      <p style={{ margin: 0, marginLeft: 15, fontSize: 14, fontWeight: 500 }}>{text}</p>
    </header>
  )
}
const inputHeader = css`
  display: flex;
  padding-top: 20px;
  padding-bottom: 20px;
  align-items: center;
`
